var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlatinumIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PLATINUM-icon",
    clipPath: "url(#clip0_15695_96146)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1402"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 37 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0585938 6.85431V6.60896C0.0585938 4.10301 3.03619 2.6017 4.99179 4.25262L7.81929 6.10355L9.39319 1.94324L9.45419 1.8207C10.5693 -0.420791 13.762 -0.415409 14.8703 1.82855L14.9307 1.95092L16.4614 6.02913L18.9518 4.33111C20.8885 2.61495 23.9386 4.10226 23.9386 6.64337V6.88931L21.3448 21.2018C21.1626 22.6571 19.9343 23.8568 18.3445 23.8568H5.65269C4.06259 23.8568 2.83409 22.6566 2.65229 21.2009L0.0585938 6.85431ZM5.36529 20.8269C5.36529 20.9891 5.49399 21.1205 5.65269 21.1205H18.3445C18.5033 21.1205 18.632 20.9891 18.632 20.8269L21.2024 6.64337C21.2024 6.36953 20.8678 6.24477 20.6951 6.4542L15.4864 10.0057C15.3535 10.1668 15.1028 10.1368 15.0099 9.94877L12.4169 3.0402C12.3108 2.82539 12.0107 2.82494 11.904 3.03943L9.28489 9.96267C9.19329 10.1469 8.94889 10.1794 8.81419 10.0252L3.29679 6.41343C3.12099 6.21224 2.79489 6.33927 2.79489 6.60896L5.36529 20.8269ZM1.74779 8.66985L1.81229 8.71203C1.79069 8.69838 1.76919 8.68433 1.74779 8.66985ZM22.2973 8.67351C22.2692 8.69356 22.2409 8.71286 22.2124 8.73142L22.2973 8.67351Z",
    fill: "#1C2A34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 37",
    d: "M5.36532 20.827L2.79492 6.60904C2.79492 6.33935 3.12103 6.21232 3.29683 6.41351L8.81422 10.0253C8.94892 10.1794 9.19332 10.147 9.28492 9.96277L11.904 3.03951C12.0107 2.82502 12.3108 2.82547 12.4169 3.04027L15.0099 9.94887C15.1028 10.1369 15.3535 10.1669 15.4864 10.0058L20.6951 6.45427C20.8678 6.24484 21.2024 6.36961 21.2024 6.64345L18.632 20.827C18.632 20.9891 18.5033 21.1206 18.3445 21.1206H5.65273C5.49403 21.1206 5.36532 20.9891 5.36532 20.827Z",
    fill: "url(#paint0_linear_15695_96146)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 42",
    d: "M6.72531 19.5022L4.78711 9.38379",
    stroke: "#F7FCFD",
    strokeOpacity: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 44",
    d: "M11.0879 9.09197L11.9986 6.69775",
    stroke: "#F7FCFD",
    strokeOpacity: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15695_96146",
    x1: 4.24812,
    y1: 2.8789,
    x2: 21.5634,
    y2: 17.7712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0236636,
    stopColor: "#71AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A58D1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15695_96146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatinumIcon);
export default __webpack_public_path__ + "static/media/PLATINUM-icon.8eaec7a0e084853d776700baf37def36.svg";
export { ForwardRef as ReactComponent };